import { StyleSheet } from 'react-native';

export const cartDisplay = StyleSheet.create({
  title: {
    marginHorizontal: 5,
    marginTop: 10,
    fontSize: 16,
    fontWeight: 800,
  },

  container: {
    flex: 1,
    paddingHorizontal: 15,
  },
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginVertical: 20,
  },
  itemImage: {
    width: 80,
    height: 80,

    borderRadius: 10,
  },
  itemDetails: {
    flexDirection: 'row',

    alignItems: 'center',
  },
  itemName: {
    fontWeight: 'bold',
    marginRight: 10,
  },
  itemPrice: {
    color: 'gray',
  },
  add: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 20,
    gap: 10,
  },

  total: {
    color: '#32de84',
    fontWeight: 'bold',
    fontSize: 18,
    marginRight: 0,
  },
  subContainer: {
    backgroundColor: 'white',
    paddingHorizontal: 30,
  },
  sub: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginVertical: 5,
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    backgroundColor: 'black',
    padding: 10,
    borderRadius: 20,
    marginLeft: 12,
    marginTop: 44,
    width: 300,
    alignItems: 'center',
  },
  buttonText: {
    color: 'white',
    fontSize: 17,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

export default cartDisplay;
